const home = [
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/index'),
    meta: {
      name: '知产交易 · 全网商标专利交易查询',
      breadCrumbName: '知产交易资讯'
    }
  },
];

export default home
